import { render, staticRenderFns } from "./GoogleFontsDropdown.vue?vue&type=template&id=c872967c&scoped=true"
import script from "./GoogleFontsDropdown.vue?vue&type=script&lang=js"
export * from "./GoogleFontsDropdown.vue?vue&type=script&lang=js"
import style0 from "./GoogleFontsDropdown.vue?vue&type=style&index=0&id=c872967c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c872967c",
  null
  
)

export default component.exports